<template>
  <div class="relative min-h-screen">
    <!-- Location Bar -->
    <div class="flex justify-center items-center h-10 w-full bg-blue-400 text-white">
      <i class="material-icons text-blue-500">location_on</i>
      <span class="mx-24">{{ address }}</span>
      <span
        class="cursor-pointer underline"
        @click="$router.push({ name: 'stations', params: { showLocationEditor: true } })"
      >
        Edit
      </span>
    </div>

    <section class="flex items-center justify-center py-6 flex-col md:flex-row" v-if="!isFirst">
      <div class="flex items-center bg-gray-400 w-96 py-3 px-4">
        <i class="material-icons text-black">search</i>
        <input
          v-model="searchText"
          class="bg-gray-400 flex-grow outline-none ml-4"
          placeholder="Search"
          @input="isTyping = true"
        />
      </div>

      <router-link to="/forum/add" tag="button" class="btn ml-4 mt-4 md:mt-0 py-3 px-10">
        Add New Forum Post
      </router-link>
    </section>

    <div class="flex justify-center" v-if="isLoading">
      <bar-loader
        class="my-8"
        color="#4db1fa"
        :width="320"
      />
    </div>

    <section class="flex-grow w-full pb-36" v-if="!isFirst">
      <div
        class="flex items-center bg-gray-400 mt-1 h-32 px-8 py-4"
        v-for="post in posts"
        :key="post.id"
      >
        <div class="ml-4 mr-12 flex-grow">
          <p>{{ post.title }}</p>
          <p class="text-xs">{{ format(post.date) }}</p>
          <p
            class="post-body text-xs text-black"
            v-line-clamp:20="3"
          >
            {{ post.body }}
          </p>
        </div>

        <button
          class="btn btn-blue h-12 w-48 flex-none"
          @click="$router.push({ name: 'post', params: { id: post.id } })"
        >
          Read Post
        </button>
      </div>
    </section>

    <base-footer class="absolute bottom-0" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';
import PostService from '@/services/PostService';

export default {
  data() {
    return {
      posts: [],
      searchText: '',
      currentPage: 1,
      lastPage: 1,
      isFirst: true,
      isLoading: true,
      isTyping: false,
    };
  },
  computed: {
    ...mapState('profile', ['address']),
  },
  watch: {
    searchText: debounce(function() {
      this.isTyping = false;
    }, 1000),

    currentPage: {
      immediate: true,
      async handler() {
        await this.fetch();
      },
    },

    async isTyping(value) {
      if (!value) {
        this.isLoading = true;

        if (this.currentPage === 1) {
          await this.fetch(false);
        } else {
          this.currentPage = 1;
        }
      }
    },

    async address() {
      if (this.currentPage === 1) {
        await this.fetch(false);
      } else {
        this.currentPage = 1;
      }
    },
  },
  methods: {
    async fetch(append = true) {
      const { data: { data, meta } } = await PostService.fetch({
        params: {
          q: this.searchText,
          page: this.currentPage,
          location: this.address,
        },
      });

      this.posts = append ? this.posts.concat(data) : data;
      this.lastPage = meta.last_page;

      if (this.isFirst) {
        this.isFirst = false;
      }

      this.isLoading = false;
    },

    nextPage() {
      if (this.currentPage === this.lastPage) {
        return;
      }
      this.currentPage++;
    },

    format(date) {
      return dayjs(date).format('MMM DD, YYYY');
    },
  },
  created() {
    this.$parent.$on('scroll_ended', this.nextPage);
  },
};
</script>

<style lang="scss" scoped>
.post-body {
  display: none;
  height: 56px;

  @media (min-width: 768px) {
    display: -webkit-box;      /* OLD - iOS 6-, Safari 3.1-6 */
    display: -moz-box;         /* OLD - Firefox 19- (buggy but mostly works) */
    display: -ms-flexbox;      /* TWEENER - IE 10 */
    display: -webkit-flex;     /* NEW - Chrome */
    display: flex;             /* NEW, Spec - Opera 12.1, Firefox 20+ */
  }
}
</style>
